import { getIn } from 'fun-util';
import EditorOverlayStateEnum from 'EditorOverlay/EditorOverlayConstants';
import { SENDER_NEVER } from 'SendForSignatureToolbar/SendForSignatureShareConstants';
import isRequestSignaturePopup from './isRequestSignaturePopup';

const senderWillSign = () =>
  ((getIn(window, 'Share', 'senderMode') || SENDER_NEVER) !== SENDER_NEVER);

export default (popup, mode) => (
  isRequestSignaturePopup(popup) &&
  senderWillSign() &&
  mode === EditorOverlayStateEnum.COMPOSE_REQUEST_FIELDS
);



// WEBPACK FOOTER //
// ./src-react/Popups/helpers/isAssignable.jsx